import { Injectable, inject } from '@angular/core'

import { Observable } from 'rxjs'

import { computeExpressionResult } from '@flowx/core-sdk'
import { ScriptingLanguage } from '@flowx/designer/modules/core/dictionary/common.types'
import { ActionTestApi } from '@flowx/designer/shared/api/action-test.api'

import { ProcessDefinition } from '../../core/dictionary/process.dictionary'

@Injectable({
  providedIn: 'root',
})
export class ExpressionEvalService {
  #actionTestApi = inject(ActionTestApi)

  evalLocal(expression: string, model: object): unknown {
    return computeExpressionResult({ expression, model }, { withIIFE: false })
  }

  evalLocalIsolated(expression: string, model: object): unknown {
    return computeExpressionResult({ expression, model }, { withIIFE: true })
  }

  evalRemote(
    processId: ProcessDefinition['id'],
    payload: {
      expression: string
      language: ScriptingLanguage
      businessRuleReferences: { resourceDefinitionId: string; appId: string }[]
      useGraalVM: boolean
    },
    model: object
  ): Observable<object> {
    return this.#actionTestApi.testRule(processId, payload, model)
  }
}
